import assetsBase from '@exodus/assets-base'
import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

const assets = assetsBase.default || assetsBase

export const ONRAMPER_API_URL = 'https://api.onramper.com'

export const ENABLED_ASSETS = {
  __proto__: null,
  '1inch_bsc': assets['1inch_bsc_61c44543']?.name,
  aave_ethereum: assets.aave?.name,
  ach_ethereum: assets.ach_ethereum_fbad19a6?.name,
  ada_bsc: assets.ada_bsc_db5f96ab?.name,
  ada_cardano: assets.cardano?.name,
  agix_ethereum: assets.agix_ethereum_84616c96?.name,
  algo_algorand: assets.algorand?.name,
  alice_bsc: assets.alice_bsc_06579e0c?.name,
  alpaca_bsc: assets.alpaca_bsc_5a5767ef?.name,
  amp_ethereum: assets.amp?.name,
  ankr_ethereum: assets.ankr?.name,
  ape_ethereum: assets.ape?.name,
  api3_ethereum: assets.api3?.name,
  arb_ethereum: assets.arb_ethereumarbone_aa4791c0?.name,
  ark_ark: assets.ark?.name,
  atom_cosmos: assets.cosmos?.name,
  aurora_ethereum: assets.aurora?.name,
  avax_avaxc: assets.avalanchec?.name,
  avax_bsc: assets.avax_bsc_6383077e?.name,
  axs_ethereum: assets.axieinfinity?.name,
  bal_ethereum: assets.balancer?.name,
  band_ethereum: assets.band_ethereum_a9ddc2a2?.name,
  bat_ethereum: assets.bat?.name,
  bch_bitcoincash: assets.bcash?.name,
  blok_polygon: assets.blok_matic_79cb78bc?.name,
  bnb_bbc: assets.bnbmainnet?.name,
  bnb_bsc: assets.bsc?.name,
  btc: assets.bitcoin?.name,
  busd_bsc: assets.busd_bsc?.name,
  chz_ethereum: assets.chiliz?.name,
  comp_ethereum: assets.compound?.name,
  crv_ethereum: assets.crv?.name,
  dai_ethereum: assets.mcd?.name,
  dash_dash: assets.dash?.name,
  dgb_digibyte: assets.digibyte?.name,
  doge_dogecoin: assets.dogecoin?.name,
  dot_polkadot: assets.polkadot?.name,
  egld_multiversx: assets.elrond?.name,
  eos_eosio: assets.eosio?.name,
  etc_ethereumclassic: assets.ethereumclassic?.name,
  eth: assets.ethereum?.name,
  eth_arbitrum: assets.ethereumarbone?.name,
  eth_base: assets.basemainnet?.name,
  eth_optimism: assets.optimism?.name,
  fil_filecoin: assets.filecoin?.name,
  ftm_fantom: assets.fantommainnet?.name,
  hbar_hedera: assets.hedera?.name,
  imx_immutable: assets.imx?.name,
  kava_kava: assets.kava?.name,
  link_ethereum: assets.chainlink?.name,
  ltc_litecoin: assets.litecoin?.name,
  mana_ethereum: assets.decentraland?.name,
  matic_ethereum: assets.polygon?.name,
  matic_polygon: assets.matic?.name,
  ont_ontology: assets.ontology?.name,
  qtum_qtum: assets.qtum?.name,
  rvn_ravencoin: assets.ravencoin?.name,
  sand_ethereum: assets.sandbox?.name,
  shib_ethereum: assets.shibainu?.name,
  snx_ethereum: assets.snx?.name,
  sol: assets.solana?.name,
  stmx_ethereum: assets.stormx?.name,
  sushi_ethereum: assets.sushiswap?.name,
  trx_tron: assets.tronmainnet?.name,
  uni_ethereum: assets.uniswap?.name,
  usdc_base: assets.usdc_basemainnet_b5a52617?.name,
  usdc_bsc: assets.usdcoin_bsc?.name,
  usdc_ethereum: assets.usdcoin?.name,
  usdc_optimism: assets.usdc_optimism_68bb70cd?.name,
  usdc_polygon: assets.usdc_matic_0a883d9b?.name,
  usdc_solana: assets.usdcoin_solana?.name,
  usdt_avaxc: assets.usdt_avalanchec_d80c1afa?.name,
  usdt_bsc: assets.usdt_bsc_ddedf0f8?.name,
  usdt_ethereum: assets.tetherusd?.name,
  usdt_optimism: assets.usdt_optimism_26487766?.name,
  usdt_polygon: assets.usdt_matic_86e249c1?.name,
  usdt_tron: assets.tetherusd_tron?.name,
  vet_vechain: assets.vechainthor?.name,
  wbtc_ethereum: assets.wbtc?.name,
  xem_nem: assets.nem?.name,
  xlm_stellar: assets.stellar?.name,
  xno_nano: assets.nano?.name,
  xrp_ripple: assets.ripple?.name,
  xtz_tezos: assets.tezos?.name,
  yfi_ethereum: assets.yfi?.name,
  zec_zcash: assets.zcash?.name,
  zil_zilliqa: assets.zilliqa?.name,
}

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  applepay: 'applepay',
  creditcard: 'creditcard',
  debitcard: 'debitcard',
  googlepay: 'googlepay',
  iach: 'iach',
  ideal: 'ideal',
  imps: 'imps',
  interacetransfer: 'interacetransfer',
  revolutpay: 'revolutpay',
  sepabanktransfer: 'sepabanktransfer',
  upi: 'upi',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.applepay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.applepay,
      type: PAYMENT_METHOD_TYPES.apple_pay,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.creditcard,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.creditcard,
      type: PAYMENT_METHOD_TYPES.card,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.debitcard,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.debitcard,
      type: PAYMENT_METHOD_TYPES.card,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.googlepay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.googlepay,
      type: PAYMENT_METHOD_TYPES.google_pay,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.iach,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.iach,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'USD', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.ideal,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.ideal,
      type: PAYMENT_METHOD_TYPES.ideal,
      countries: [{ id: 'NL', enabled: true }],
      currencies: [{ id: 'EUR', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.imps,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.imps,
      type: PAYMENT_METHOD_TYPES.imps,
      countries: [{ id: 'IN', enabled: true }],
      currencies: [{ id: 'INR', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.interacetransfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.interacetransfer,
      type: PAYMENT_METHOD_TYPES.interacetransfer,
      countries: [{ id: 'CA', enabled: true }],
      currencies: [{ id: 'CAD', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.revolutpay,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.revolutpay,
      type: PAYMENT_METHOD_TYPES.revolut_pay,
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.sepabanktransfer,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.sepabanktransfer,
      type: PAYMENT_METHOD_TYPES.bank,
      currencies: [{ id: 'EUR', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.upi,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.upi,
      type: PAYMENT_METHOD_TYPES.upi,
      countries: [{ id: 'IN', enabled: true }],
      currencies: [{ id: 'INR', enabled: true }],
    }),
  ],
])

export const ONRAMPER_PROVIDERS = {
  __proto__: null,
  alchemypay: 'alchemypay',
  banxa: 'banxa',
  coinify: 'coinify',
  gatefi: 'gatefi',
  guardarian: 'guardarian',
  koywe: 'koywe',
  localramp: 'localramp',
  neocrypto: 'neocrypto',
  onrampmoney: 'onrampmoney',
  topper: 'topper',
  transfi: 'transfi',
  utorg: 'utorg',
}

export const ORDER_STATUSES = {
  __proto__: null,
  canceled: 'canceled',
  completed: 'completed',
  failed: 'failed',
  new: 'new',
  paid: 'paid',
  pending: 'pending',
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [ORDER_STATUSES.completed],
  failed: [ORDER_STATUSES.failed, ORDER_STATUSES.canceled],
  'in-progress': [ORDER_STATUSES.new, ORDER_STATUSES.paid, ORDER_STATUSES.pending],
}
